import { Link } from '@tanstack/react-router';

import { cn } from '@/lib/cn';

export function DateRangeFilter({
  current,
  options,
  basePath = '/admin',
}: {
  current: string;
  options: { key: string; label: string }[];
  basePath?: string;
}) {
  return (
    <nav aria-label="Date range" className="flex flex-wrap gap-1.5">
      {options.map((o) => (
        <Link
          key={o.key}
          // `basePath` is a prop, so neither it nor its search shape can be
          // checked against the route tree the way a literal destination can.
          // This is the only unchecked navigation in the app; every other Link
          // resolves to a real route with real params.
          to={basePath as never}
          search={{ range: o.key } as never}
          aria-current={current === o.key ? 'page' : undefined}
          className={cn(
            'inline-flex h-10 items-center rounded-[10px] border px-3 text-sm font-semibold transition-colors',
            current === o.key
              ? 'border-ink bg-ink text-panel'
              : 'border-line-strong bg-panel hover:border-ink/40',
          )}
        >
          {o.label}
        </Link>
      ))}
    </nav>
  );
}
